enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

const LogColors = {
  [LogLevel.DEBUG]: '\x1b[36m', // cyan
  [LogLevel.INFO]: '\x1b[32m', // green
  [LogLevel.WARN]: '\x1b[33m', // yellow
  [LogLevel.ERROR]: '\x1b[31m', // red
  reset: '\x1b[0m',
} as const;

interface LoggerConfig {
  prefix: string;
  debug?: boolean;
}

interface Logger {
  debug: (message: unknown, ...args: unknown[]) => void;
  info: (message: unknown, ...args: unknown[]) => void;
  warn: (message: unknown, ...args: unknown[]) => void;
  error: (message: unknown, ...args: unknown[]) => void;
}

let loggerCounter = 0;

export function useLogger({ prefix, debug = false }: LoggerConfig): Logger {
  let loggerDebugPrefix = '';
  if (debug) {
    loggerCounter++;
    loggerDebugPrefix = `[#${loggerCounter}] `;
  }

  if (debug) {
    console.groupCollapsed(`${prefix} logger initialized ${loggerDebugPrefix}(call stack)`);
    console.trace();
    console.groupEnd();
  }

  const formatMessage = (level: LogLevel) => `${loggerDebugPrefix}${LogColors[level]}[${level}]${LogColors.reset} ${prefix}:`;

  return {
    debug: (...args: unknown[]) => {
      if (debug) {
        console.log(formatMessage(LogLevel.DEBUG), ...args);
      }
    },
    info: (...args: unknown[]) => {
      console.info(formatMessage(LogLevel.INFO), ...args);
    },
    warn: (...args: unknown[]) => {
      console.warn(formatMessage(LogLevel.WARN), ...args);
    },
    error: (...args: unknown[]) => {
      console.error(formatMessage(LogLevel.ERROR), ...args);
    },
  };
}
